var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "nav-link py-0 text-muted",
      attrs: { href: "#" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.toggleStar.apply(null, arguments)
        },
      },
    },
    [
      _c("i", {
        class: {
          far: !_vm.isStarred,
          "fas text-warning": _vm.isStarred,
          "fa-star": true,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }